/* ==========================================================================
   PEONIA · Landing
   Aparicion al hacer scroll, preguntas, selector de estilo, barra fija y
   alta al carrito. Idempotente: la seccion se puede repetir y el editor de
   temas vuelve a montar sin duplicar oyentes.
   ========================================================================== */
(function () {
  'use strict';

  if (window.PeoLanding) {
    window.PeoLanding.init();
    return;
  }

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Aparicion
     --------------------------------------------------------------- */
  var revObserver = null;

  function getRevObserver() {
    if (revObserver || !('IntersectionObserver' in window)) return revObserver;
    revObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-vis');
          revObserver.unobserve(e.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px' }
    );
    return revObserver;
  }

  function initRevelado(scope) {
    var els = scope.querySelectorAll('.peo-rev:not([data-peo-rev])');
    var io = getRevObserver();
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-peo-rev', '1');
      if (!io || reduce) {
        els[i].classList.add('is-vis');
      } else {
        // escalona los hermanos para que la fila no aparezca de golpe
        var idx = Number(els[i].getAttribute('data-peo-orden') || 0);
        els[i].style.transitionDelay = Math.min(idx, 6) * 70 + 'ms';
        io.observe(els[i]);
      }
    }
  }

  /* ---------------------------------------------------------------
     Preguntas
     --------------------------------------------------------------- */
  function togglePregunta(head) {
    var acc = head.parentElement;
    var abierta = acc.classList.contains('is-open');
    acc.classList.toggle('is-open', !abierta);
    head.setAttribute('aria-expanded', String(!abierta));
  }

  /* ---------------------------------------------------------------
     Selector de estilo: filtra las tarjetas ya pintadas por Liquid.
     Nada de un catalogo paralelo en JS que se desincronice del real.
     --------------------------------------------------------------- */
  function initEstilos(scope) {
    var grupos = scope.querySelectorAll('[data-peo-estilos]:not([data-peo-init])');
    for (var i = 0; i < grupos.length; i++) {
      grupos[i].setAttribute('data-peo-init', '1');
      bindEstilos(grupos[i]);
    }
  }

  function bindEstilos(grupo) {
    var id = grupo.getAttribute('data-peo-estilos');
    var rejilla = document.querySelector('[data-peo-grid="' + id + '"]');
    if (!rejilla) return;
    var tarjetas = [].slice.call(rejilla.querySelectorAll('[data-peo-ocasion]'));
    var vacio = document.querySelector('[data-peo-vacio="' + id + '"]');
    var conteo = document.querySelector('[data-peo-conteo="' + id + '"]');
    var total = tarjetas.length;

    // El conteo es la unica senal inequivoca de que el filtro hizo algo.
    function pintarConteo(n, etiqueta) {
      if (!conteo) return;
      var pieza = n === 1 ? 'vestido' : 'vestidos';
      conteo.textContent = etiqueta
        ? n + ' ' + pieza + ' para ' + etiqueta
        : total + ' ' + (conteo.getAttribute('data-peo-todos') || 'vestidos disponibles');
    }
    pintarConteo(total, '');

    grupo.addEventListener('click', function (event) {
      var btn = event.target.closest('.peo-estilo');
      if (!btn) return;

      var yaEstaba = btn.classList.contains('is-on');
      var chips = grupo.querySelectorAll('.peo-estilo');
      for (var i = 0; i < chips.length; i++) chips[i].classList.remove('is-on');
      chips = null;

      // volver a tocar el mismo filtro lo quita: nunca se queda encerrada
      var filtro = yaEstaba ? '' : btn.getAttribute('data-peo-estilo') || '';
      if (!yaEstaba) btn.classList.add('is-on');

      var visibles = 0;
      tarjetas.forEach(function (card) {
        // Token exacto, no subcadena: con tallas, "S" haría match dentro de
        // "S/M" y el filtro mentiría.
        var occ = (card.getAttribute('data-peo-ocasion') || '').toLowerCase().split(/\s+/);
        var pasa = !filtro || occ.indexOf(filtro.toLowerCase()) !== -1;
        card.hidden = !pasa;
        if (pasa) visibles++;
      });

      if (vacio) vacio.hidden = visibles !== 0;
      pintarConteo(visibles, filtro ? btn.textContent.trim() : '');
      track('peo_filtro_estilo', { estilo: filtro || 'todos', resultados: visibles });
    });
  }

  /* ---------------------------------------------------------------
     Carrusel de reseñas
     El desplazamiento es nativo (con el dedo funciona solo); las flechas
     son para el escritorio. Si no hay nada que desplazar se esconden:
     un control muerto se ve peor que no tenerlo.
     --------------------------------------------------------------- */
  function initCarruseles(scope) {
    var nodos = scope.querySelectorAll('[data-peo-carrusel]:not([data-peo-init])');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].setAttribute('data-peo-init', '1');
      bindCarrusel(nodos[i]);
    }
  }

  function bindCarrusel(caja) {
    var pista = caja.querySelector('[data-peo-pista]');
    var prev = caja.querySelector('[data-peo-prev]');
    var next = caja.querySelector('[data-peo-next]');
    if (!pista || !prev || !next) return;

    function paso() {
      var card = pista.querySelector('.peo-testi');
      if (!card) return 320;
      var gap = parseFloat(getComputedStyle(pista).columnGap || '0') || 0;
      return (card.getBoundingClientRect().width + gap) * 2;
    }

    // El inicio real de la pista no siempre es 0: el anclaje deja un
    // remanente de unos pixeles. En vez de pelear con la causa, se toma el
    // menor desplazamiento observado como el verdadero inicio; asi la flecha
    // izquierda se apaga cuando de verdad no hay nada a la izquierda.
    var minScroll = null;

    function flechas() {
      var actual = pista.scrollLeft;
      if (minScroll === null || actual < minScroll) minScroll = actual;
      var max = pista.scrollWidth - pista.clientWidth - 4;
      var hay = max > minScroll;
      prev.hidden = !hay;
      next.hidden = !hay;
      prev.disabled = actual <= minScroll + 4;
      next.disabled = actual >= max;
    }

    function mover(dir) {
      pista.scrollBy({ left: dir * paso(), behavior: reduce ? 'auto' : 'smooth' });
      // el evento scroll llega en el cuadro siguiente; con desplazamiento
      // suave, mucho despues. Se refresca el estado al terminar.
      setTimeout(flechas, 60);
      setTimeout(flechas, 700);
    }
    prev.addEventListener('click', function () { mover(-1); });
    next.addEventListener('click', function () { mover(1); });
    // El anclaje de scroll del navegador empuja la pista unos pixeles cuando
    // las tarjetas aparecen (el reveal cambia sus medidas). Mientras nadie la
    // haya tocado se devuelve al inicio, o la flecha izquierda queda activa
    // sin nada a la izquierda.
    var tocado = false;
    function marcarTocado() { tocado = true; }
    prev.addEventListener('click', marcarTocado);
    next.addEventListener('click', marcarTocado);
    pista.addEventListener('pointerdown', marcarTocado);
    pista.addEventListener('wheel', marcarTocado, { passive: true });
    pista.addEventListener('touchstart', marcarTocado, { passive: true });
    pista.addEventListener('keydown', marcarTocado);

    function asentar() {
      if (!tocado && pista.scrollLeft > 0) pista.scrollLeft = 0;
      flechas();
    }

    pista.addEventListener('scroll', flechas, { passive: true });
    window.addEventListener('resize', flechas);
    asentar();
    // las fotos entran despues y cambian el ancho util
    setTimeout(asentar, 400);
    setTimeout(asentar, 1200);
    setTimeout(asentar, 2400);
  }

  /* ---------------------------------------------------------------
     Barra fija: aparece al pasar el disparador
     --------------------------------------------------------------- */
  function initSticky(scope) {
    var barras = scope.querySelectorAll('[data-peo-sticky]:not([data-peo-init])');
    for (var i = 0; i < barras.length; i++) {
      var bar = barras[i];
      bar.setAttribute('data-peo-init', '1');
      var sel = bar.getAttribute('data-peo-tras');
      var disparador = sel ? document.querySelector(sel) : null;

      if (!disparador || !('IntersectionObserver' in window)) {
        // Sin disparador la barra se queda siempre visible: hay que acomodar
        // igual, o tapa el pie y se encima con los botones de las apps.
        bar.classList.add('is-on');
        acomodar(bar, true);
        setTimeout(acomodarLuego(bar), 600);
        continue;
      }
      bindSticky(bar, disparador);
    }
  }

  /* La barra fija se monta encima de lo que las apps ya tienen abajo:
     WhatsApp, el boton del quiz, el de volver arriba, los cupones. En vez de
     perseguir el selector de cada app —que cambian sin avisar— se detecta lo
     que de verdad esta fijo y pegado al fondo, y se sube. Los widgets suelen
     inyectarse como hijos directos de <body>, asi que basta con mirar dos
     niveles y no toda la pagina. */
  function flotantesDeAbajo(bar) {
    var out = [];
    // Se recorre todo el body: los widgets no siempre cuelgan del primer
    // nivel (el boton de volver arriba de este tema va mucho mas adentro).
    // Se hace una sola vez por aparicion, asi que el costo no se nota.
    var todos = document.body.querySelectorAll('*');
    for (var i = 0; i < todos.length; i++) revisar(todos[i]);
    function revisar(el) {
      if (!el || el === bar || bar.contains(el) || el.contains(bar)) return;
      if (el.hasAttribute('data-peo-movido')) return;
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { return; }
      if (cs.position !== 'fixed') return;
      var base = parseFloat(cs.bottom);
      if (isNaN(base) || base > 120) return;
      var r = el.getBoundingClientRect();
      if (r.height === 0 || r.height > window.innerHeight * 0.5) return;
      out.push({ el: el, base: base });
    }
    return out;
  }

  function acomodar(bar, visible) {
    var alto = bar.offsetHeight || 0;
    document.body.style.setProperty('--peo-sticky-h', alto + 'px');
    document.body.classList.toggle('peo-has-sticky', visible);
    document.body.classList.toggle('peo-sticky-on', visible);

    if (visible) {
      flotantesDeAbajo(bar).forEach(function (f) {
        f.el.setAttribute('data-peo-movido', String(f.base));
        f.el.style.bottom = f.base + alto + 14 + 'px';
      });
    } else {
      var movidos = document.querySelectorAll('[data-peo-movido]');
      for (var i = 0; i < movidos.length; i++) {
        movidos[i].style.bottom = movidos[i].getAttribute('data-peo-movido') + 'px';
        movidos[i].removeAttribute('data-peo-movido');
      }
    }
  }

  function acomodarLuego(bar) {
    return function () { acomodar(bar, true); };
  }

  function bindSticky(bar, disparador) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', visible);
          // el widget de WhatsApp entra tarde: se reacomoda al siguiente cuadro
          acomodar(bar, visible);
          if (visible) setTimeout(function () { acomodar(bar, true); }, 600);
        });
      },
      { threshold: 0 }
    );
    io.observe(disparador);
  }

  /* ---------------------------------------------------------------
     Alta al carrito
     Va por la API Ajax a proposito: es la ruta que Shopify instrumenta,
     de ahi sale 'product_added_to_cart' y de ahi el AddToCart del pixel.
     Un enlace /cart/<variante>:1 agrega del lado del servidor y ese evento
     no sale. Si el alta falla, cae al enlace de respaldo.
     --------------------------------------------------------------- */
  function ruta(p) {
    var raiz =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (raiz.charAt(raiz.length - 1) !== '/') raiz += '/';
    return raiz + p;
  }

  function agregar(boton) {
    var id = boton.getAttribute('data-peo-add');
    if (!id || boton.hasAttribute('data-peo-busy')) return;

    var respaldo = boton.getAttribute('data-peo-respaldo') || ruta('cart');
    var destino = boton.getAttribute('data-peo-dest') === 'cart' ? 'cart' : 'checkout';
    var etiqueta = boton.innerHTML;

    boton.setAttribute('data-peo-busy', '1');
    boton.setAttribute('aria-busy', 'true');
    boton.innerHTML = boton.getAttribute('data-peo-cargando') || 'Un momento…';

    fetch(ruta('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () {
        window.location.href = ruta(destino);
      })
      .catch(function () {
        boton.removeAttribute('data-peo-busy');
        boton.removeAttribute('aria-busy');
        boton.innerHTML = etiqueta;
        window.location.href = respaldo;
      });
  }

  /* ---------------------------------------------------------------
     Selector de talla + comprar
     El equipo pidio que todo lleve al checkout. Sin elegir talla eso
     compraria la primera disponible, asi que el boton no avanza hasta
     que hay talla: se marca el aviso y se lleva la vista al selector.
     --------------------------------------------------------------- */
  function tallaElegida(scope) {
    var sel = scope.querySelector('[data-peo-selector] .peo-talla--btn.is-on');
    return sel ? sel.getAttribute('data-peo-variante') : '';
  }

  function elegirTalla(btn) {
    var caja = btn.closest('[data-peo-selector]');
    if (!caja) return;
    var todas = caja.querySelectorAll('.peo-talla--btn');
    for (var i = 0; i < todas.length; i++) {
      todas[i].classList.remove('is-on');
      todas[i].setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('is-on');
    btn.setAttribute('aria-pressed', 'true');

    var aviso = caja.querySelector('[data-peo-aviso]');
    if (aviso) aviso.hidden = true;

    // el precio puede variar por talla: se refresca con el de la variante
    var raiz = caja.closest('.peo-sec') || document;
    var precio = raiz.querySelector('[data-peo-precio]');
    var pv = btn.getAttribute('data-peo-precio-var');
    if (precio && pv) precio.textContent = pv;

    track('peo_elige_talla', { talla: btn.textContent.trim() });
  }

  function comprar(boton) {
    if (boton.hasAttribute('data-peo-busy')) return;
    var raiz = boton.closest('.peo-sec') || document;
    var id = tallaElegida(raiz);

    if (!id) {
      var caja = raiz.querySelector('[data-peo-selector]');
      var aviso = raiz.querySelector('[data-peo-aviso]');
      if (aviso) aviso.hidden = false;
      if (caja) {
        caja.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        caja.classList.add('peo-late');
        setTimeout(function () { caja.classList.remove('peo-late'); }, 900);
      }
      return;
    }

    var destino = boton.getAttribute('data-peo-dest') === 'cart' ? 'cart' : 'checkout';
    var etiqueta = boton.innerHTML;
    boton.setAttribute('data-peo-busy', '1');
    boton.setAttribute('aria-busy', 'true');
    boton.innerHTML = boton.getAttribute('data-peo-cargando') || 'Un momento…';

    fetch(ruta('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () { window.location.href = ruta(destino); })
      .catch(function () {
        boton.removeAttribute('data-peo-busy');
        boton.removeAttribute('aria-busy');
        boton.innerHTML = etiqueta;
        window.location.href = ruta('cart/' + id + ':1');
      });
  }

  /* ---------------------------------------------------------------
     Medicion. Los eventos estandar (PageView, ViewContent, AddToCart)
     los emite Shopify solo; aqui solo van los propios de la landing.
     --------------------------------------------------------------- */
  function track(evento, datos) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: evento }, datos || {}));
  }

  /* ---------------------------------------------------------------
     Clics
     --------------------------------------------------------------- */
  function onClick(event) {
    if (!event.target.closest) return;

    // talla elegida desde la foto de la tarjeta: entra con la variante puesta
    var atajo = event.target.closest('[data-peo-ir]');
    if (atajo) {
      event.preventDefault();
      window.location.href = atajo.getAttribute('data-peo-ir');
      return;
    }

    var talla = event.target.closest('.peo-talla--btn');
    if (talla && !talla.disabled) {
      event.preventDefault();
      elegirTalla(talla);
      return;
    }

    var comprarBtn = event.target.closest('[data-peo-comprar]');
    if (comprarBtn) {
      event.preventDefault();
      comprar(comprarBtn);
      return;
    }

    var add = event.target.closest('[data-peo-add]');
    if (add) {
      event.preventDefault();
      agregar(add);
      return;
    }

    var head = event.target.closest('.peo-acc__h');
    if (head) {
      togglePregunta(head);
      return;
    }

    var ancla = event.target.closest('.peo a[href^="#"]');
    if (!ancla) return;
    var id = ancla.getAttribute('href');
    if (!id || id === '#') return;
    var destino = document.querySelector(id);
    if (!destino) return;
    event.preventDefault();
    destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', id);
  }

  function init(raiz) {
    var scope = raiz && raiz.querySelectorAll ? raiz : document;
    initRevelado(scope);
    initEstilos(scope);
    initCarruseles(scope);
    initSticky(document);
  }

  window.PeoLanding = { init: init, track: track };
  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
